<template>
  <div class="index-container">
    <AboveTheFold />
    <Together />
    <HeroSection />
    <Container />
    <Core />
    <LayoutContainer />
    <AppendixLayout />
  </div>
</template>

<script>
import AboveTheFold from './AboveTheFold/AboveTheFold.vue';
import Together from './Together/ESGStrategy.vue';
import Topics from './2024KeyTopics/Topics.vue';
import HeroSection from './SKESGStory/HeroSection.vue';
import Container from './Materiality/Container.vue';
import Core from './Core/core.vue';
import LayoutContainer from './Road/LayoutContainer.vue';
import AppendixLayout from './Appendix/AppendixLayout.vue';

export default {
  name: 'Index',
  components: {
    AboveTheFold,
    Together,
    Topics,
    HeroSection,
    Container,
    Core,
    LayoutContainer,
    AppendixLayout
  }
};
</script>

<style scoped>
.index-container > * {
  flex-shrink: 0;
  position: relative;
}
</style>
